export default __webpack_public_path__ + "static/Plots0086-21ed000c10bf6f80cf4b6c44a924f0d0.jpg";